import React, { Component } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Card, CardBody, Button, CardTitle, CardText, Row, Col } from 'reactstrap';
import classnames from 'classnames';
import {Redirect} from 'react-router-dom'
import UserEditForm from '../../../components/Admin/User/EditForm'
class EditUser extends Component {
    render(){
        return (
            <div style={{ marginLeft:"5%", marginRight:"5%" }}>
            <UserEditForm />
            </div>
        )
    }
}

export default EditUser